export const normalizeLicensePlate = (value) => {
  if (!value) {
    return value;
  }
  return value.replace(/[^a-zA-Z0-9- ]/, "");
};
